import {
  Nav as HeaderNav,
  Line as HeaderLine,
  Top as HeaderTop,
  User as HeaderUser,
  NavMobile as HeaderNavMobile,
  Addmenu as HeaderAddMenu,
} from '@/components/parts/header';
import LayoutDefault from '@/components/layout/Default.vue';
import ExtButton from '@/components/ext/Button.vue';
import ExtLink from '@/components/ext/Link.vue';
import FooterAliasMenu from '@/components/parts/nav/FooterAlias.vue';
import FooterMenu from '@/components/parts/nav/Footer.vue';
import AppSvgIcon from '../../uikit/components/AppSvgIcon/AppSvgIcon';
import PopupForms from './popup/forms';
import SignLink from '@/components/parts/header/SignLink.vue';
import Scoreboard from '@/components/parts/scoreboard';
import EsiaLink from '@/components/esialink';
import DeferredLink from '@/components/parts/header/deferred';
import Confirm from '@/components/emailconfirm';
import { ProfileMenu } from '@/pages/profile';
import UseCookie from '@/components/usecookie';
import mixinNav from '../mixin-nav';
import mixinHash from './popup/forms/mixin';
import pfdodCheck from '@/mixins/isPfdodCheck';
import isProfile from '@/mixins/isProfile';
import mixinOrganizations from '@/mixins/organizationsModule';
import resendConfirmEmail from '@/mixins/resendConfirmEmail';
import isAuthTokens from '@/mixins/isAuthTokens';
import isAuthorized from '@/mixins/isAuthorized';
import colorMainMenu from '@/mixins/colorMainMenu';
import isLocation from '@/mixins/isLocation';
import checkMobile from '@/mixins/checkMobile';
import Accessibility from '@/uikit/mixins/accessibility';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import Messages from '@/components/parts/messages';
import mixinModules from '@/mixins/isModules';

import { Modal as modalWindow } from '@/components/modal';
import ModalForm from '@/components/modalform';
import WarningPopup from '@/components/warning';
import ModalDefault from '@/components/modal/default';

import { isUserFriendlyEmail } from '@/tools/validators/emailValidators';

import {
  HASH_SIGNIN,
  HASH_SIGNUP,
  HASH_MODAL,
  HASH_WARNING,
  HASH_NOKIDS,
  ESIA_500_ERROR,
} from './const.js';

import ConsultationsSvg from '../profile/views/consultations/ConsultationsSvg';
import Modal from '../../components/panel/Modal';
import ConsultationsModal from '../../components/ordersProcessForms/consultation/ConsultationsModal.vue';
import esiaStore from './popup/forms/esia-store';
import ModalEssia from '../../components/modalEssia/ModalEssia.vue';
import RegisterAuthModal from '../../components/parts/modules/register_auth_modal/RegisterAuthModal.vue';
import RequestForm from '../vacancies/form/components/requestform/RequestForm.vue';

const SEARCH_FIELD_NAME = 'term';
const RULES_AND_POLICY = 'Правила сайта и политика конфиденциальности';
const CERT_DOD_RULES = 'Правила применения сертификатов ПФ ДОД';
const MODAL_HEADER_REGISTRATION = 'Здравствуйте, регистрация прошла успешно!';
const MODAL_HEADER_CONFIRMEMAIL = 'Здравствуйте, подтвердите почту!';
const AUTH_MAESSAGE =
  'Для просмотра контента страницы вам необходимо войти в личный кабинет!';

export default {
  name: 'ViewDefault',

  inject: ['$config', '$api'],

  components: {
    RequestForm,
    ModalDefault,
    ModalEssia,
    RegisterAuthModal,
    DeferredLink,
    ExtButton,
    ExtLink,
    FooterMenu,
    FooterAliasMenu,
    HeaderLine,
    HeaderTop,
    HeaderNav,
    HeaderUser,
    HeaderNavMobile,
    LayoutDefault,
    PopupForms,
    modalWindow,
    ModalForm,
    Scoreboard,
    SignLink,
    WarningPopup,
    HeaderAddMenu,
    Confirm,
    LoadingSpinner,
    Messages,
    EsiaLink,
    ProfileMenu,
    UseCookie,
    AppSvgIcon,
    ConsultationsSvg,
    Modal,
    ConsultationsModal,
  },

  mixins: [
    mixinNav,
    mixinHash,
    mixinOrganizations,
    pfdodCheck,
    resendConfirmEmail,
    colorMainMenu,
    isAuthTokens,
    isAuthorized,
    checkMobile,
    isLocation,
    isProfile,
    mixinModules,
    Accessibility
  ],

  data: () => ({
    submitDataEsia: {},
    programId: null,
    justSignUp: false,
    showConfirmEmail: true,
    modalTextHeader: MODAL_HEADER_REGISTRATION,
    authMessage: AUTH_MAESSAGE,
    disabled: false,
    showContent: true,
    showSpinner: false,
    showAuthMessage: false,
    searchTerm: '',
    consultationAddModal: false,
    isMount: false,
    policyURL: {
      text: RULES_AND_POLICY,
      to: { name: 'terms' },
      target: '_blank',
    },
    message: {
      type: 'success',
      text: {
        description: 'Консультация создана успешно!',
        title: '',
        warning: '',
      },
    },
    errors: [],
  }),

  computed: {
    isModalAuth() {
      return this.routeHash.split('?')[0] === 'esia_form' && this.isMount;
    },
    agreeWithTheCookie() {
      return !this.state.agreeWithTheCookie;
    },

    externalAuthName() {
      const { dnevnikRu } = this.$config.auth || {};
      return dnevnikRu && dnevnikRu.name;
    },

    externalAuthLogo() {
      const { dnevnikRu } = this.$config.auth || {};
      return dnevnikRu && dnevnikRu.logo;
    },

    externalAuthHref() {
      const { dnevnikRu } = this.$config.auth || {};
      return dnevnikRu && dnevnikRu.link;
    },

    hasExternalAuth() {
      const { $config, $store } = this;
      const { auth = {} } = $config;
      return auth.dnevnikRu && $store.getters.hasApiModuleDnevnikRu;
    },

    hasEsiaAuth() {
      return this.$store.getters.hasApiModuleEsia;
    },

    hasBasicAuth() {
      return !this.hasExternalAuth;
    },

    deferredCount() {
      return this.$store.state.deferred.items.length;
    },

    basketdCount() {
      const { items, show } = this.$store.state.basket;
      if (show) return items && items.length;
      return 0;
    },

    hasHeaderMenu() {
      const { headerMenu } = this;
      return headerMenu && headerMenu.length > 0;
    },

    hasAskQuestion() {
      const { askQuestion } = this;
      return askQuestion && askQuestion.length > 0;
    },

    hasTopScoreboard() {
      const { isAuthorized, isPfdodModule } = this;
      return isPfdodModule && isAuthorized;
    },

    hasTopLine() {
      const { hasAskQuestion, hasTopScoreboard } = this;
      return hasTopScoreboard || hasAskQuestion;
    },

    sortPopup() {
      const { routeHash } = this;
      return routeHash === HASH_MODAL;
    },

    searchValue() {
      return this.$route.query[this.searchName] || this.searchTerm;
    },

    routeData() {
      const { name, query, params } = this.$route;
      return {
        name: name === 'map' ? 'map' : 'events',
        params: { ...params },
        query: { ...query },
      };
    },

    routeSignin() {
      const { name, params, query } = this.$route;
      return { name, params, query, hash: ['#', HASH_SIGNIN].join('') };
    },

    routeSignup() {
      const { name, params, query } = this.$route;
      return { name, params, query, hash: ['#', HASH_SIGNUP].join('') };
    },

    profileData() {
      const name = this.$route.name.substring(0, 7);
      return name === 'profile' ? 1 : null;
    },

    mainMenu() {
      return this.mainNav;
    },

    firmInfo() {
      const { orgName, ogrn, inn, address } = this.regionProfile;
      const list = [];
      if (orgName) {
        list.push({ text: orgName });
      }
      if (ogrn) {
        list.push({ text: `ОГРН ${ogrn}` });
      }
      if (inn) {
        list.push({ text: `ИНН ${inn}` });
      }
      if (inn) {
        list.push({ text: address });
      }
      return list;
    },

    state() {
      return this.$store.state;
    },

    regionProfile() {
      return this.state.regionProfile;
    },

    logoTextSize() {
      const { logoTextSize } = this.regionProfile;
      return logoTextSize ? logoTextSize : '';
    },

    phone() {
      const { contactPhone } = this.regionProfile;
      const list = Array.isArray(contactPhone)
        ? contactPhone
        : (contactPhone || '').split(',');
      return list.map((phone) => phone.replace(/[^0-9]/gim, '').trim());
    },

    email() {
      return this.regionProfile.contactEmail || '';
    },

    dataSupport() {
      const { emailSupport, phone } = this.regionProfile;
      const dataObj = {};

      if (emailSupport) dataObj.email = emailSupport;
      if (phone) dataObj.phone = phone;

      return dataObj;
    },

    user() {
      return this.state.user;
    },

    profile() {
      return this.user.profile;
    },

    isChildren() {
      return this.user.children;
    },

    isProfileLoading() {
      return this.user.loading;
    },



    isModalVisible() {
      return [HASH_MODAL, HASH_WARNING, HASH_NOKIDS].some(
        (hash) => hash === this.routeHash
      );
    },

    isModalRegisterAuthOpen() {
      return this.routeHash === 'register_auth';
    },

    isFriendlyEmail() {
      const { profile } = this;
      try {
        const problemEmails =
          this.$store.state.regionProfile.constants.problem_email_domains;
        return profile && isUserFriendlyEmail(problemEmails)(profile.email);
      } catch (err) {
        return true;
      }
    },

    isVerifiedEmail() {
      const { profile } = this;
      return profile && profile.is_verified;
    },

    confirmEmail() {
      const { isAuthorized, isVerifiedEmail, isFriendlyEmail } = this;
      return isAuthorized && (!isVerifiedEmail || !isFriendlyEmail);
    },

    userEmail() {
      const { profile } = this;
      return profile && profile.email;
    },

    userFio() {
      const { user, checkMobile } = this;
      const { fio, first_name, last_name, patro_name } = user.profile;
      if (checkMobile.windowWidth <= 640) {
        const mobileFio = `${last_name} ${first_name[0]}.`;
        return patro_name ? `${mobileFio} ${patro_name[0]}.` : mobileFio;
      } else {
        return fio;
      }
    },

    childrenData() {
      const { isPfdodModule, isChildren } = this;
      const result = [];

      if (isPfdodModule && !!isChildren) {
        isChildren.map(
          ({
            first_name,
            certificate_type,
            certificate_number,
            certificate_amount_total,
            certificate_amount_on_hold,
            certificate_amount_withdraw,
            certificate_amount_current,
          }) => {
            const data = {
              name: first_name,
              total: certificate_amount_total,
              hold: certificate_amount_on_hold,
              withdraw: certificate_amount_withdraw,
              current: certificate_amount_current,
            };

            if (!!certificate_number && certificate_type === 'finance')
              result.push(data);
          }
        );
      }

      return result;
    },

    navRouteName() {
      if (this.$route.name === 'activities-calendar')
        return 'activities-calendar';
      if (this.isActivities) return 'activities';
      if (this.isModules) return 'modules';
      return this.$route.name === 'map' ? 'map' : 'events';
    },

    footerMenuList() {
      const { links } = this.regionProfile;

      if (!links) {
        return [];
      }

      return links.map(({ name, url }) => {
        const external =
          url.indexOf('http://') === 0 || url.indexOf('https://') === 0;
        return {
          text: name,
          to: url,
          target: external ? '_blank' : null,
          external,
        };
      });
    },

    privacyPolicyLink() {
      const { privacyPolicyFileUrl, rulesPfdodFileUrl } = this.regionProfile;
      const result = [];

      if (privacyPolicyFileUrl) result.push(this.policyURL);

      if (rulesPfdodFileUrl)
        result.push({
          text: CERT_DOD_RULES,
          to: { name: 'term-pfdod' },
          target: '_blank',
        });

      return result;
    },

    footerAliasList() {
      const { footerAliasList } = this.regionProfile;
      return footerAliasList && footerAliasList.length > 0
        ? footerAliasList.map((item) => ({
            ...item,
            icon: item.icon.replace(/@\/assets\//gi, '/public/'),
          }))
        : null;
    },

    searchName() {
      // return this.$route.name === 'organizations' ? 'organization' : SEARCH_FIELD_NAME;
      return SEARCH_FIELD_NAME;
    },

    isNoKidsText() {
      return this.$route.hash === ['#', HASH_NOKIDS].join('');
    },

    isRegistrationText() {
      return this.noRegistrationOrOrder ? '' : 'Регистрация';
    },

    deferredLink() {
      return {
        name: 'profile-favorite',
      };
    },

    basketLink() {
      return {
        name: 'new-program',
      };
    },

    profileLink() {
      return {
        name: 'profile-cabinet',
      };
    },
  },

  watch: {
    isProfileLoading(value) {
      const { isAuthTokens, isAuthorized, showContent } = this;
      if (value && isAuthTokens && !isAuthorized && !showContent) {
        this.showContent = false;
      }
    },

    $route(to, from) {
      const { isAuthorized } = this;
      if (!isAuthorized && to.hash === '#question') {
        this.$router.push({ hash: HASH_SIGNUP });
      }
      if (to.name !== 'search') {
        this.searchTerm = '';
      }
    },

    '$store.state.user.nube'(value) {
      if (value) {
        this.justSignUp = true;
      }
    },

    isAuthorized(value) {
      const {
        $route: { name },
      } = this;

      if (value) {
        this.showContent = true;
        this.noSpinnerContent();
        if (name === 'event-card') this.$store.dispatch('getQuestionnaireForm');
        if (!value) this.$store.commit('setQuestionnaireForm');
      }
    },
  },

  created() {
    const { $route, hasEsiaAuth, isAuthorized } = this;
    const {
      meta: { isAuth },
      query: { xEsiaCode },
    } = $route;
    if (isAuth) {
      this.showSpinner = true;
    }
    if (hasEsiaAuth && !isAuthorized && xEsiaCode) {
      this.showContent = false;
    }
  },

  mounted() {
    const {
      isAuthTokens,
      hasEsiaAuth,
      $route: {
        name,
        query: { xEsiaCode },
      },
    } = this;
    this.$nextTick(() => {
      this.$store.dispatch('deferred/init');
      this.$store.dispatch('basket/init');
      if (isAuthTokens) {
        this.showSpinner = false;
        if (name !== 'default-info') this.$store.dispatch('user/init');
      } else {
        this.showAuthMessage = true;
      }
      this.isMount = true;
    });
    if (hasEsiaAuth) {
      const savedUrl = localStorage.getItem('pageUrl');
      if (xEsiaCode && xEsiaCode.length) {
        this.$store
          .dispatch('user/esiaSignup', xEsiaCode)
          .then(({ municipality_id }) => {
            if (municipality_id === '0' || !municipality_id) {
              this.$router.push({ name: 'profile-settings-address' });
            } else if (savedUrl) {
              this.$router.push(JSON.parse(savedUrl), () => {
                localStorage.removeItem('pageUrl');
              });
            } else {
              this.$router.push({ query: null });
            }
          })
          .catch((error) => {
            this.$router.push({ query: null, hash: HASH_SIGNIN });
            this.showContent = true;

            if (error && error.err_code === 500) {
              esiaStore.esiaError = ESIA_500_ERROR;
            }

            if (error && error.err_code === 400) {
              const [{ msg }] = error.errors;
              esiaStore.esiaError = [msg];
            }
          });
      }
    }
    // Удалить когда главный лейаут будет по всему сайту
    this.injectCode();
  },

  updated() {
    const {
      showSpinner,
      $route: { matched },
    } = this;
    if (!matched.some((record) => record.meta.isProfile) && showSpinner) {
      this.noSpinnerContent();
    }
  },

  methods: {
    cloneAttributes(target, source) {
      [...source.attributes].forEach((attr) => {
        target.setAttribute(attr.nodeName, attr.nodeValue);
      });
      target.textContent = source.textContent;
    },
    openModal() {
      this.$ui.$modal.show('ConsultationModal', {
        settings: {
          size: {
            width: '500px',
            minHeight: '300px',
            height: '535px',
          },
          title: 'Добавить новую консультацию',
        },
        bind: this,
        slots: {
          body: {
            component: ConsultationsModal,
          },
        },
      });
    },
    async acceptModal() {
      try {
        this.submitDataEsia.$v.$touch();
        if (this.submitDataEsia.$v.$invalid) {
          if (typeof this.fillErrors === 'function') {
            this.fillErrors();
          }
          return;
        }
        await this.$store.dispatch(
          'user/essia_signin',
          this.submitDataEsia.submitData
        );
        this.$router.push({ name: 'profile-favorite' });
        this.$toast.success('Успешно!');
      } catch (errors) {
        if (Array.isArray(errors)) {
          this.errors = errors;
        }
        this.$toast.error('Ошибка отправки данных!');
      }
    },
    closeEssiaModal() {
      this.$router.push('');
    },
    // Удалить когда главный  лейаут будет по всему сайту
    injectCode() {
      const codeWrapper = this.$refs.code;
      const code = this.regionProfile.code;
      if (!!code) {
        const parser = new DOMParser();
        const elems = parser.parseFromString(`<div>${code}</div>`, 'text/html').body.children[0].children;
        for (const el of elems) {
          const item = document.createElement(el.tagName);
          this.cloneAttributes(item, el);
          codeWrapper.append(item);
        }
      }
    },

    saveCookie() {
      this.$store.commit('setAgreeCookie', true);
    },

    noSpinnerContent() {
      this.showSpinner = false;
      this.showAuthMessage = false;
    },

    getProgrammId(data) {
      this.programId = data;
    },

    forceCloseConfirmEmail() {
      this.showConfirmEmail = false;
    },

    confirm() {
      if (this.confirmEmail) {
        this.resendConfirmEmail()
          .then(({ data: { success } }) => {
            if (success) {
              this.modalTextHeader = MODAL_HEADER_CONFIRMEMAIL;
              this.justSignUp = true;
              this.disabled = true;
            }
          })
          .catch((err) => {
            this.disabled = false;
          });
      }
    },

    clearDisabled() {
      this.disabled = false;
    },

    closeModalConfirmEmail() {
      this.justSignUp = false;
      if (this.$store.state.nextOpenModuleCard) {
        this.$store.nextOpenModuleCard = false;
        return;
      }
      if (this.modalTextHeader === MODAL_HEADER_REGISTRATION) {
        if (!this.$store.state.user.after_register) {
          this.$router.push({ name: 'profile-settings' });
        }
      } else {
        this.modalTextHeader = MODAL_HEADER_REGISTRATION;
      }
    },

    async onSubmitSearch(data) {
      const { term } = data;
      if (!term) {
        return;
      }
      this.searchTerm = term;
      this.findEvent(data);
    },

    findEvent(data) {
      const { fieldName, term } = data;
      const { $store, routeData, $router } = this;
      const { municipality = null } = $store.state;
      const base = municipality === null ? {} : { municipality };

      const routeParams = {
        name: 'search',
        params: {},
        path: '/search',
      };
      const query = {
        ...base,
        ...routeParams.query,
        [fieldName]: term,
      };
      delete query.page;
      $router.push({ ...routeParams, query });
    },
  },

  metaInfo() {
    const { seoTitle, seoDescription, seoKeywords } =
      this.$store.state.regionProfile;
    return {
      title: seoTitle,
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            seoDescription || 'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content:
            seoKeywords || 'блог, цопп, профессиональная, подготовка, центр',
        },
        {
          name: 'viewport',
          content:
            'width=device-width, initial-scale=1, maximum-scale=1, minimal-ui',
        },
      ], //,
      //link: []
    };
  },
};



// WEBPACK FOOTER //
// ./src/pages/default/component.js